import React, { useEffect, useState } from 'react';
import { ELDA_URL } from '../../../variables';
import { environment } from '../../../utils/constants';

const InternalEldaPage = () => {
    const [eldaPath, setEldaPath] = useState('');
  
    useEffect(() => {
            const generateEldaUrl =
                environment.gitBranch === 'develop'
                    ? window.location.pathname.slice(13)
                    : window.location.pathname.slice(30);
        if (window.location.search) {
            setEldaPath(generateEldaUrl + window.location.search);
        } else {
            setEldaPath(generateEldaUrl);
        }
    }, []);

    console.log("window.location.pathname.slice(29)", window.location.pathname.slice(13))
    console.log("ELDA_URL", `${ELDA_URL}/${eldaPath}`)
    console.log(environment.gitBranch)

    return (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <iframe
                src={`${ELDA_URL}/${eldaPath}`}
                title="InternalElda"
                style={{ width: '100%', height: 'calc(100vh - 95px)' }}
            ></iframe>
        </div>
    );
};

export default InternalEldaPage;
